import React from "react"
import PropTypes from "prop-types"

const TextHighlighter = ({ color, children }) => {
    return <span style={{ color: color }}>{children}</span>
}

TextHighlighter.propTypes = {
    color: PropTypes.string,
    children: PropTypes.string,
}

export default TextHighlighter
